import * as yup from 'yup'

export enum EventType {
  ONE_TIME = 'ONE_TIME',
  RECURRING = 'RECURRING',
}

export enum HostType {
  Staff = 'Staff',
  Resident = 'Resident',
}

export const guestSchema = yup.object().shape({
  name: yup.string().required('Guest name is required'),
  email: yup.string().email('Invalid email address').required('Guest email is required'),
  phoneNumber: yup
    .string()
    .matches(/^(?:\+234|0)?(70|80|81|90|91)\d{8}$/, 'Phone number is not valid')
    .required('Phone number is required'),
})

export const GuestInvitation = yup.object().shape({
  email: yup.string().email('Invalid email address').nullable(),
  firstName: yup.string().required('Guest first name is required'),
  lastName: yup.string().required('Guest last name is required'),
  phoneNumber: yup
    .string()
    .matches(/^\d+$/, 'Phone number must contain only digits')
    .nullable(),
  name: yup.string().notRequired(),
  type: yup
    .string()
    .oneOf([EventType.ONE_TIME, EventType.RECURRING], 'Invalid event type')
    .notRequired(),
  property: yup.string().required('Property is required'),
  resident: yup.string().required('Resident is required'),
  purposeOfVisit: yup.string().required('Purpose of visit is required'),
})
